/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const FormContainer = styled.form`
  all: unset;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const SectionWrap = styled.div`
  display: flex;
`;

export const LoaderBox = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
`;
